// pages/Application.jsx
import React, { useRef } from 'react';
import { Link } from 'react-router-dom';
import './Application.css';
import imgMetal from '../../images/image/metalurgy.jpg';
import imgChem from '../../images/image/Сhemicals.jpg';
import imgElec from '../../images/image/Electronics.jpg';
import imgPrib from '../../images/image/Priborostroenie.jpg';
import imgNefGaz from '../../images/image/Nefte-gaz.webp';
import imgBuil from '../../images/image/Building.webp';
import imgEat from '../../images/image/Eating.webp';

const Application = () => {
    // Создаем refs для каждого раздела
    const refs = {
        metallurgy: useRef(null),
        chemical: useRef(null),
        electronics: useRef(null),
        instrumentation: useRef(null),
        oilgas: useRef(null),
        construction: useRef(null),
        food: useRef(null)
    };

    // Данные для отраслей
    const industries = [
        {
            id: 'metallurgy',
            name: 'Металлургия',
            icon: '🏭',
            image: imgMetal,
            description: 'В металлургии востребованы материалы, обладающие высоким сопротивлением пластической деформации и разрушению в условиях воздействия высоких температур и окислительных сред. Из жаропрочных сплавов изготавливаются тяжелонагруженные детали. Жаропрочные сплавы могут быть на алюминиевой, титановой, железной, медной, кобальтовой и никелевой основах. Помимо этого широкое применение нашли сплавы с высоким электросопротивлением. Металлопродукция из прецизионных сплавов с высоким электросопротивлением используется для изготовления нагревательных элементов в высокотемпературных промышленных и лабораторных печах, в печах обжига и сушки, для изготовления резистивных элементов, трубчатых электронагревателей, нагревательных устройств бытовых и прочих электрических аппаратов теплового действия.',
            alloys: [
                { name: 'ХН70Ю', path: '/splavi/heat-resistant-alloys/37' },
                { name: 'Х20Н80', path: '/splavi/high-resistance/1' },
                { name: 'Х15Н60', path: '/splavi/high-resistance/3' },
                { name: '12Х18Н9', path: '/splavi/corrosion-resistant/52' }
            ]
        },
        {
            id: 'chemical',
            name: 'Химическая промышленность',
            icon: '🧪',
            image: imgChem,
            description: 'Химическая промышленность является одним из основных потребителей коррозионностойких сталей. Известно, что одной из важнейших проблем химических производств является проблема коррозии. С увеличением объема производства растут издержки на защиту от коррозии и замену вышедшего из строя оборудования, потери от простоев и аварий. Наиболее эффективным путем решения этих вопросов является использование в химическом машиностроении современных коррозионностойких материалов. Эксплуатационная надежность химической аппаратуры, изготовленной из нержавеющих кислотоупорных сталей, особенно коррозионная стойкость сварных соединений, определяется качеством самих сталей и технологией изготовления аппаратуры. Исключительное сочетание коррозионной стойкости и необходимых механических свойств при комнатной и повышенных температурах, хорошая свариваемость и достаточно высокие прочность и пластичность сварных соединений послужили основанием к широкому применению в химической отрасли.',
            alloys: [
                { name: '06ХН28МДТ', path: '/splavi/corrosion-resistant/47' },
                { name: '10Х17Н13М2Т', path: '/splavi/corrosion-resistant/51' },
                { name: '12Х18Н9', path: '/splavi/corrosion-resistant/52' },
                { name: '04Х19Н9', path: '/splavi/corrosion-resistant/46' }
            ]
        },
        {
            id: 'electronics',
            name: 'Электроника',
            icon: '💻',
            image: imgElec,
            description: 'Возможности ускорения научно-технического прогресса во многом зависят от рационального использования, улучшения качества уже существующих материалов и создания принципиально новых материалов, отвечающих требованиям новых поколений высокоэффективной техники. Особое место среди современных металлических материалов занимают прецизионные сплавы, т. е. материалы с заранее заданными особыми физическими свойствами. Эти материалы находят широкое применение в электротехнической отрасли.',
            alloys: [
                { name: '36КНМ', path: '/splavi/soft-magnetic/17' },
                { name: '50Н', path: '/splavi/soft-magnetic/18' },
                { name: '50НХС', path: '/splavi/soft-magnetic/19' },
                { name: '76НХД', path: '/splavi/soft-magnetic/20' },
                { name: '79НМ', path: '/splavi/soft-magnetic/21' },
                { name: '80НХС', path: '/splavi/soft-magnetic/22' },
                { name: '81НМА', path: '/splavi/soft-magnetic/23' },
                { name: '27КХ', path: '/splavi/high-induction/24' },
                { name: '49КФ', path: '/splavi/high-induction/25' },
                { name: '52К11Ф', path: '/splavi/hard-magnetic/26' },
                { name: '36НХТЮ', path: '/splavi/elastic/27' },
                { name: '40КХНМ', path: '/splavi/elastic/28' },
                { name: '42НХТЮ', path: '/splavi/elastic/29' },
                { name: '29НК', path: '/splavi/tclr/30' },
                { name: '32НКД', path: '/splavi/tclr/31' },
                { name: '36Н', path: '/splavi/tclr/32' },
                { name: '42Н', path: '/splavi/tclr/33' },
                { name: '52Н', path: '/splavi/tclr/34' }
            ]
        },
        {
            id: 'instrumentation',
            name: 'Приборостроение',
            icon: '📊',
            image: imgPrib,
            description: 'Прецизионные сплавы — незаменимые материалы при изготовлении узлов особо чувствительных приборов и установок, уникальной экспериментальной и малогабаритной аппаратуры, различного рода датчиков, преобразователей энергии. Прецизионные сплавы являются основой прогресса точного приборостроения и др. отраслей техники; изготовляются преимущественно в виде тонкой ленты и проволоки, а также в виде поковок, листов, прутков, полиметаллической проволоки и ленты, монокристаллов. Для достижения наивысшего уровня свойств прецизионным сплавам необходимы, как правило, особые способы выплавки, деформирования, специальные режимы термической обработки, качественная отделка поверхности. Прецизионные сплавы требуют высокой культуры эксплуатации.',
            alloys: [
                { name: '79НМ', path: '/splavi/soft-magnetic/21' },
                { name: '80НХС', path: '/splavi/soft-magnetic/22' },
                { name: '81НМА', path: '/splavi/soft-magnetic/23' },
                { name: '81НМА', path: '/splavi/soft-magnetic/23' },
                { name: '50НХС', path: '/splavi/soft-magnetic/19' },
                { name: '50Н', path: '/splavi/soft-magnetic/18' },
                { name: '36КНМ', path: '/splavi/soft-magnetic/17' },
                { name: '76НХД', path: '/splavi/soft-magnetic/20' },
                { name: '27КХ', path: '/splavi/high-induction/24' },
                { name: '49КФ', path: '/splavi/high-induction/25' },
                { name: '52К11Ф', path: '/splavi/hard-magnetic/26' },
                { name: '36НХТЮ', path: '/splavi/elastic/27' },
                { name: '42НХТЮ', path: '/splavi/elastic/29' },
                { name: '40КХНМ', path: '/splavi/elastic/28' },
                { name: '29НК', path: '/splavi/tclr/30' },
                { name: '32НКД', path: '/splavi/tclr/31' },
                { name: '36Н', path: '/splavi/tclr/32' },
                { name: '42Н', path: '/splavi/tclr/33' },
                { name: '52Н', path: '/splavi/tclr/34' }
            ]
        },
        {
            id: 'oilgas',
            name: 'Нефтегазовая отрасль',
            icon: '🛢️',
            image: imgNefGaz,
            description: 'Неблагоприятные условия при добыче и переработке нефти и газа зачастую требуют использования коррозионностойких сплавов. Сплавы на никель-хром-молибденовой основе созданы для того, чтобы продукция с их использованием обладала не только антикоррозионными свойствами, но и устойчивостью к высоким температурам, прочностью и пластичностью. Такие сплавы, используемые в оборудовании для нефтяной промышленности, имеют хорошие литейные свойства и высокую прочность. Таким образом, они могут применяться для производства дисков, листов, труб и стержней.',
            alloys: [
                { name: '04Х19Н9', path: '/splavi/corrosion-resistant/46' },
                { name: '10Х17Н13М2Т', path: '/splavi/corrosion-resistant/51' },
                { name: '12Х18Н9', path: '/splavi/corrosion-resistant/52' },
                
            ]
        },
        {
            id: 'construction',
            name: 'Строительство',
            icon: '🏗️',
            image: imgBuil,
            description: 'В данной отрасли особенно востребована сварочная проволока 04Х19Н9 . Именно ее применение гарантирует прочность сварочных швов: снижение риска возникновения межкристаллической коррозии и увеличение прочности соединения конструкции. Как правило, проволока 04Х19Н9 предназначена для соединения изделий (труб, бойлеров) из таких сплавов как 10X17Н1ЗМ2Т, 08X18Н10 или 12X18Н10Т.',
            alloys: [
                 { name: '04Х19Н9', path: '/splavi/corrosion-resistant/46' }
            ]
        },
        {
            id: 'food',
            name: 'Пищевая промышленность',
            icon: '🍽️',
            image: imgEat,
            description: 'Сегодня нержавеющая сталь вместе со стеклом и некоторыми видами пластмасс является практически единственным материалом, который одобрен как сырье для изготовления оборудования для производства, хранения и транспортировки пищевых продуктов. Это обусловлено высокими требованиями по гигиене, токсичности и др. Гигиена имеет наиважнейшее значение в пищевой индустрии. Она в значительной мере определяет качество продукта на всем пути от сырья, через технологический процесс, к потребителю.',
            alloys: [
               { name: '04Х19Н9', path: '/splavi/corrosion-resistant/46' },
               { name: '12Х18Н9', path: '/splavi/corrosion-resistant/52' }
            ]
        }
    ];

    // Функция для плавной прокрутки к секции
    const scrollToSection = (ref) => {
        ref.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    return (
        <div className="application-page">
            <div className="application-header">
                <h1>Области применения</h1>
                <p className="application-description">
                    Продукция компании Эскалайн широко используется в различных отраслях промышленности. 
                    Наши материалы обеспечивают надежность, долговечность и высокое качество конечных изделий.
                </p>
            </div>

            {/* Сетка иконок-ссылок */}
            <div className="industries-grid">
                {industries.map((industry) => (
                    <div 
                        key={industry.id}
                        className="industry-icon-card"
                        onClick={() => scrollToSection(refs[industry.id])}
                    >
                        <div className="industry-icon">
                            {industry.icon}
                        </div>
                        <div className="industry-name">{industry.name}</div>
                    </div>
                ))}
            </div>

            {/* Детальные секции с описанием */}
            <div className="industries-details">
                {industries.map((industry, index) => (
                    <div 
                        key={industry.id}
                        ref={refs[industry.id]}
                        className={`detail-section ${index % 2 === 0 ? 'image-left' : 'image-right'}`}
                    >
                        <div className="detail-image">
                            <img 
                                src={industry.image} 
                                alt={industry.name}
                                onError={(e) => {
                                    e.target.src = 'https://via.placeholder.com/400x300/1a1a1a/dc2626?text=' + industry.name;
                                }}
                            />
                        </div>
                        <div className="detail-content">
                            <h2>{industry.name}</h2>
                            <p>{industry.description}</p>
                            
                            {/* Блок со ссылками на сплавы */}
                            <div className="alloys-links-block">
                                <p className="alloys-label">
                                    <span className="alloys-label-icon">🔗</span>
                                    Применяемые сплавы:
                                </p>
                                <div className="alloys-links-container">
                                    {industry.alloys.map((alloy, idx) => (
                                        <Link 
                                            key={idx}
                                            to={alloy.path}
                                            className="alloy-link-inline"
                                        >
                                            {alloy.name}
                                        </Link>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            {/* Блок с преимуществами */}
            <div className="advantages-footer">
                <h3>Почему выбирают наши сплавы?</h3>
                <div className="advantages-list">
                    <div className="advantage-item">
                        <span>✓</span>
                        <p>Высокое качество и стабильность характеристик</p>
                    </div>
                    <div className="advantage-item">
                        <span>✓</span>
                        <p>Соответствие стандартам ГОСТ</p>
                    </div>
                    <div className="advantage-item">
                        <span>✓</span>
                        <p>Индивидуальный подход к каждому клиенту</p>
                    </div>
                    <div className="advantage-item">
                        <span>✓</span>
                        <p>Широкий ассортимент типоразмеров и марок сплавов</p>
                    </div>
                    <div className="advantage-item">
                        <span>✓</span>
                        <p>Оперативная доставка по всей России</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Application;